import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Report} from '../models/report';
import {MemberBackgroundService} from './member-background.service';
import {MemberBackgroundData} from '../models/member-background-data';
import {SpinnerService} from '../shared/waiting/spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  public annuities_2010: any[] = []
  public annuities_2011: any[] = []
  public annuities_2012: any[] = []
  public annuities_2013: any[] = []
  public annuities_2014: any[] = []
  public annuities_2015: any[] = []
  public annuities_2016: any[] = []
  public annuities_2017: any[] = []
  public annuities_2018: any[] = []
  public annuities_2019: any[] = []
  public annuities_2020: any[] = []
  public annuities_2021: any[] = []
  public annuities_2022: any[] = []
  public annuities_2023: any[] = []
  public annuities_2024: any[] = []
  public annuities_2025: any[] = []
  public annuities_2026: any[] = []

  public formacao: any[] = []

  constructor (
    public db: AngularFirestore,
    public _memberBackgroundService: MemberBackgroundService,
    private _spinnerService: SpinnerService,
  ) { }

  select () {
    return this.db.collection<Report>('sbccv_reports', ref =>
      ref.orderBy('name', 'asc')).snapshotChanges();
  }

  getAnnuities () {
    const waiting = this._spinnerService.show();
    return this.db.collection<any>('sbccv_orders', ref => ref
      .where('returnCode', '==', '00')
      .orderBy('product_name')).snapshotChanges()
      .subscribe((result) => {
        result.forEach((item) => {
          if (item.payload.doc.data().deleted !== true) {
            let id = item.payload.doc.data().product_id;
            switch (id) {
              case '28aLrhRyXgTKYsIinYVW': // 2010
                this.addAnnuites(item.payload.doc.data(), this.annuities_2010)
                break;
              case 'tXF6E78JvyJ1hAhgoykc': // 2011
                this.addAnnuites(item.payload.doc.data(), this.annuities_2011)
                break;
              case '4JicOMIjiLbLdB8TNnLv': // 2012
                this.addAnnuites(item.payload.doc.data(), this.annuities_2012)
                break;
              case '1Kj378241IxX7Xr2tPZi': // 2013
                this.addAnnuites(item.payload.doc.data(), this.annuities_2013)
                break;
              case 'zFVLvgBMKUHlsKR3tcMU': // 2014
                this.addAnnuites(item.payload.doc.data(), this.annuities_2014)
                break;
              case '7y1FQp8h7i2U9pMJyYX2': // 2015
                this.addAnnuites(item.payload.doc.data(), this.annuities_2015)
                break;
              case 'FdDgr87oUEQ3jwqdf8pb': // 2016
                this.addAnnuites(item.payload.doc.data(), this.annuities_2016)
                break;
              case 'kbOVmTnPizmkMpJbf8mu': // 2017
                this.addAnnuites(item.payload.doc.data(), this.annuities_2017)
                break;
              case 'ZxmIvkOktdNcpFjiMi3V': // 2018
                this.addAnnuites(item.payload.doc.data(), this.annuities_2018)
                break;

              case 'qLAWEqkMXNSoyh3TWP84': // 2019
                this.addAnnuites(item.payload.doc.data(), this.annuities_2019)
                break;
              case 'l5HoYFLNMtvtLVaNN3YZ': // 2020
                this.addAnnuites(item.payload.doc.data(), this.annuities_2020)
                break;
              case 'lnKqXBA5X1VmJ2mOyKk9': // 2021
                this.addAnnuites(item.payload.doc.data(), this.annuities_2021)
                break;
              case 'PhPlaSimcJe1KrFRnyeW': // 2022
                this.addAnnuites(item.payload.doc.data(), this.annuities_2022)
                break;
              case 'xHpeBnUNmYkcGIMBAwjV': // 2023
                this.addAnnuites(item.payload.doc.data(), this.annuities_2023)
                break;
              case 'QarxayQfwZLQUl0GUBzV': // 2024
                this.addAnnuites(item.payload.doc.data(), this.annuities_2024)
                break;
              case 'S21FvmKtLEXrcKNXLwwS': // 2025
                this.addAnnuites(item.payload.doc.data(), this.annuities_2025)
                break;
              case '9tLOkTL9e7tqXtGz1jmA': // 2026
                this.addAnnuites(item.payload.doc.data(), this.annuities_2026)
                break;
            }
          }
        })
        waiting.close();
      })
  }

  getFormacao () {
    const waiting = this._spinnerService.show();
    return this.db.collection<MemberBackgroundData>('sbccv_members_background', ref => ref
      .orderBy('member_name', 'asc'))
      .get()
      .subscribe((result) => {
        this.formacao = result.docs.map((item) => {
          return {
            member_id: item.data().member_id,
            member_name: item.data().member_name,
            dateStart: item.data().dateStart,
            dateEnd: item.data().dateEnd,
            location: item.data().location,
            text: item.data().text
          }
        })
        waiting.close();
        // console.log("report formação: " + JSON.stringify(this.formacao))
      })
  }

  addAnnuites (item: any, collection: any[]) {
    collection.push({
      "member_id": item.member_id,
      "member_name": item.member_name,
      "product_id": item.product_id,
      "product_name": item.product_name,
      "category": item.category_name,
      "value": item.total
    })
  }

  add (entity: Report) {
    delete entity.id;
    return this.db.collection('sbccv_reports').add(Object.assign({}, entity));
  }

  edit (entity: Report) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_reports').doc(id).set(Object.assign({}, entity), {'merge': true});
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_reports').doc(entity_id).delete();
  }

}
